"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _iconGallery = require("web/shared/icons_gallery/iconGallery");
var _useProgressTween = require("web/shared/icons/useProgressTween");
var _styles = require("web/shared/icons_gallery/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The icon gallery's color-vector picker: slots every rendered glyph
* receives, so a multi-slot drawing can be judged in color rather than in
* black.
*
* Whether the popover is open, and the hover cycle on its button, are this
* component's own business and live here. The picked colors do not — the cards
* are drawn with them too, so they belong to the page that owns both.
*/ // The quick palettes. Orange-red runs dark to light so a layered glyph's
// back-to-front slots shade like embers to sparks; the accent ramp runs
// light to dark around the product accent (#2f6df6).
const PRESETS = [{
  label: "Reset",
  hexes: _iconGallery.RESET_HEXES
}, {
  label: "Rainbow",
  hexes: ["#ef4444", "#f97316", "#eab308", "#22c55e", "#3b82f6", "#6366f1", "#8b5cf6"]
}, {
  label: "Orange-red",
  hexes: ["#7f1d1d", "#b91c1c", "#dc2626", "#ea580c", "#f97316", "#fb923c", "#fdba74"]
}, {
  label: "Accent",
  hexes: ["#dce7fd", "#b9cffb", "#8fb1f9", "#6693f8", "#4a7ef7", "#2f6df6", "#1f4fc0"]
}];
function IconColorPicker(_ref) {
  let pickedHexes = _ref.pickedHexes,
    onChange = _ref.onChange,
    colorVector = _ref.colorVector; // The picker dropdown; its button's icon plays one full cycle per hover
  // (each mouseenter advances the tween target a whole cycle, which ends at
  // rest).
  const _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    pickerOpen = _useState2[0],
    setPickerOpen = _useState2[1];
  const _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    pickerCycles = _useState4[0],
    setPickerCycles = _useState4[1];
  const pickerProgress = (0, _useProgressTween.useProgressTween)(pickerCycles, _iconGallery.CYCLE_DURATION_MS, "linear");
  const setHexAt = (slot, hex) => {
    onChange(previous => previous.map((existing, index) => index === slot ? hex : existing));
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.pickerContainer)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
      type: "button",
      "aria-label": "Pick icon colors",
      "aria-expanded": pickerOpen,
      "aria-haspopup": "true",
      onClick: () => setPickerOpen(open => !open),
      onMouseEnter: () => setPickerCycles(count => count + 1)
    }, stylex.props(_styles.styles.pickerButton)), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        name: "circle-hexagon-grid",
        size: "l",
        progress: pickerProgress,
        colors: colorVector
      })
    })), pickerOpen ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)({
        type: "button",
        "aria-hidden": "true",
        tabIndex: -1,
        onClick: () => setPickerOpen(false)
      }, stylex.props(_styles.styles.pickerBackdrop))), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({
        role: "group",
        "aria-label": "Icon color vector"
      }, stylex.props(_styles.styles.pickerPopover)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.pickerTitle)), {}, {
          children: "Color vector"
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.swatchRow)), {}, {
          children: pickedHexes.map((hex, slot) => /*#__PURE__*/(0, _jsxRuntime.jsx)("label", (0, _objectSpread2.default)((0, _objectSpread2.default)({
            title: "Color ".concat(slot + 1)
          }, stylex.props(_styles.styles.swatch)), {}, {
            style: {
              backgroundColor: hex
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", (0, _objectSpread2.default)({
              type: "color",
              value: hex,
              onChange: event => setHexAt(slot, event.target.value)
            }, stylex.props(_styles.styles.swatchInput)))
          }), slot))
        })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.presetRow)), {}, {
          children: [PRESETS.map(preset => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
            type: "button",
            onClick: () => onChange(() => preset.hexes)
          }, stylex.props(_styles.styles.presetButton)), {}, {
            children: preset.label
          }), preset.label)), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
            type: "button",
            onClick: () => onChange(previous => previous.map(() => previous[0]))
          }, stylex.props(_styles.styles.presetButton)), {}, {
            children: "Match first"
          }))]
        }))]
      }))]
    }) : null]
  }));
}
var _default = exports.default = IconColorPicker;